import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Dialog } from './Dialog';
import { Dialogs } from '../constants/Dialogs';
import { closeDialog as closeDialogFunc } from '../ducks/dialogSlice';
import { WhatsNew } from '../types/WhatsNew';
import { AppState } from '../types/AppState';
import { WhatsNewPreview } from './WhatsNewPreview';

interface StateProps {
  loading: boolean;
  whatsNewRecords: WhatsNew[];
}

interface DispatchProps {
  closeDialog(): void;
}

type Props = StateProps & DispatchProps;

const WhatsNewSalesViewDialogComponent: React.FC<Props> = ({ loading, whatsNewRecords, closeDialog }: Props) => (
  <Dialog dialogKey={Dialogs.WhatsNewSalesView}>
    <WhatsNewPreview loading={loading} whatsNewRecords={whatsNewRecords} closeDialog={closeDialog} />
  </Dialog>
);

const mapStateToProps = ({
  settings: { whatsNewSalesViewDialog: whatsNewRecords = [], loading },
}: AppState): StateProps => ({
  loading,
  whatsNewRecords,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  closeDialog: (): void => {
    dispatch(closeDialogFunc());
  },
});

export const WhatsNewSalesViewDialog = connect(mapStateToProps, mapDispatchToProps)(WhatsNewSalesViewDialogComponent);
